import { FC, SVGProps } from 'react';

export const DeactivateLinkIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M21.5 27V24.25M24.25 21.5H27M9.19375 15.0279L7.2495 16.9721C6.21802 18.0036 5.63855 19.4026 5.63855 20.8613C5.63855 22.32 6.21802 23.719 7.2495 24.7505C8.28098 25.782 9.67996 26.3615 11.1387 26.3615C12.5974 26.3615 13.9964 25.782 15.0279 24.7505L16.9735 22.8063M7.75 10.5H5M10.5 5V7.75M15.0279 9.19375L16.9721 7.2495C17.4808 6.72944 18.0875 6.31544 18.7573 6.03149C19.427 5.74753 20.1464 5.59926 20.8739 5.59525C21.6013 5.59125 22.3223 5.73159 22.9951 6.00815C23.668 6.28471 24.2792 6.692 24.7936 7.20643C25.3079 7.72086 25.7151 8.33221 25.9915 9.00508C26.268 9.67796 26.4082 10.399 26.4041 11.1264C26.3999 11.8539 26.2515 12.5733 25.9675 13.243C25.6834 13.9126 25.2693 14.5193 24.7491 15.0279L22.8049 16.9721"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
